import { render, staticRenderFns } from "./RegisterLTD.vue?vue&type=template&id=438dd3b8&"
import script from "./RegisterLTD.vue?vue&type=script&lang=js&"
export * from "./RegisterLTD.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLTD.vue?vue&type=style&index=0&id=438dd3b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports